import React from 'react';
import { FaCertificate, FaFlask, FaCheckCircle, FaShieldAlt } from 'react-icons/fa';

const QualityPage = () => {
  const certifications = [
    { name: 'ISO 9001:2015 Certified', description: 'Quality Management System' },
    { name: 'ISO 22000:2018 Certified', description: 'Food Safety Management System' },
    { name: 'GMP Certified', description: 'Good Manufacturing Practice' },
    { name: 'AYUSH Certified', description: 'Ministry of AYUSH, Government of India' },
    { name: 'HALAL Certified', description: 'Halal Product Certification' },
    { name: 'ORGANIC Certified', description: 'Organic Product Certification' },
    { name: 'Schedule M Compliant', description: 'Pharmaceutical Manufacturing Standards' },
  ];

  const qualitySteps = [
    { title: 'Raw Material Testing', description: 'All raw materials undergo rigorous quality checks before acceptance' },
    { title: 'In-Process Quality Control', description: 'Continuous monitoring during manufacturing process' },
    { title: 'Finished Product Testing', description: 'Comprehensive testing of final products before dispatch' },
    { title: 'Documentation & Traceability', description: 'Complete batch records and traceability systems' },
  ];

  return (
    <div className="min-h-screen" data-testid="quality-page">
      <section className="bg-gradient-to-r from-[#0F5132] to-[#0F5132] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Quality Assurance</h1>
          <p className="text-xl text-gray-100 max-w-3xl mx-auto">
            Uncompromising standards in every step of manufacturing
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0F5132] mb-4">Our Certifications</h2>
            <p className="text-lg text-gray-600">Certified by leading national and international bodies</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {certifications.map((cert, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-8 text-center hover:shadow-xl transition-all">
                <FaCertificate className="text-5xl text-[#0F5132] mx-auto mb-4" />
                <h3 className="text-xl font-bold text-[#0F5132] mb-2">{cert.name}</h3>
                <p className="text-sm text-gray-600">{cert.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0F5132] mb-4">Quality Control Process</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {qualitySteps.map((step, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#0F5132] rounded-lg flex items-center justify-center flex-shrink-0">
                    <FaCheckCircle className="text-[#0F5132] text-xl" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#0F5132] mb-2">{step.title}</h3>
                    <p className="text-gray-600">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#0F5132] rounded-3xl p-12 text-white text-center">
            <FaShieldAlt className="text-6xl text-[#0F5132] mx-auto mb-6" />
            <h2 className="text-3xl font-bold mb-4">Our Quality Commitment</h2>
            <p className="text-xl text-gray-100 max-w-3xl mx-auto">
              We are committed to delivering products that meet the highest standards of quality, safety, and efficacy. Every product undergoes rigorous testing in our in-house laboratory before reaching you.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QualityPage;